import emojiRegex from "emoji-regex";

const emojiPattern = emojiRegex();

export const normalizeMarkdownContent = (markdown: string): string => {
  const withoutWrappingCodeFence = markdown.replace(/^\s*```[^\n\r]*\r?\n([\s\S]*?)\r?\n```\s*$/, "$1");

  return withoutWrappingCodeFence.replace(emojiPattern, "");
};
